import type { Site } from "./types";

export const ValtechSiteAudienceIdMap: Record<Site, number[]> = {
	Intermediaries: [1186],
	IndividualInvestors: [1185],
	Institutional: [1187],
	International: [1317, 1318, 1319, 1320, 1321, 1322, 1323, 1581],
	Microsite: [0],
};

export const RedirectMap: Record<Site, string> = {
	Intermediaries: "/uk/intermediaries",
	IndividualInvestors: "/uk/individual-investors",
	Institutional: "/uk/institutional-investors",
	International: "/international",
	Microsite: "/",
};

export const storybookQueryParamKeys = ["globals", "args"];

export const queryParamsToOmit = [...storybookQueryParamKeys, "version"];
